export default Object.freeze({
  ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
  SINGLE_USE_PASSWORD: 'SINGLE_USE_PASSWORD',
  FAILED_PAYMENTS: 'FAILED_PAYMENTS',
});
